export const OWNER_REGISTRATION_ACTIONS = [
  'login',
  'recover_account',
  'request_authorized_claim',
] as const;

export type OwnerRegistrationAction = (typeof OWNER_REGISTRATION_ACTIONS)[number];

export interface OwnerRegistrationConflict {
  reason_code?: string;
  action?: string;
  actions?: string[];
}

export function classifyOwnerRegistrationPrecheck(
  result: { available: boolean; reason_code?: string; kind?: 'nif' | 'nipc' },
): 'available' | 'invalid' | 'duplicate' {
  if (result.kind === 'nif') return 'invalid';
  if (result.available) return 'available';
  if (result.reason_code === 'invalid_tax_identifier' || result.reason_code === 'nipc_required') return 'invalid';
  return 'duplicate';
}

const isOwnerRegistrationAction = (value: string): value is OwnerRegistrationAction =>
  (OWNER_REGISTRATION_ACTIONS as readonly string[]).includes(value);

export function getOwnerRegistrationConflictActions(
  conflict: OwnerRegistrationConflict,
): OwnerRegistrationAction[] {
  const serverActions = (conflict.actions ?? []).filter(isOwnerRegistrationAction);
  if (serverActions.length > 0) return serverActions;

  // The precheck and older API responses may carry only the primary action.
  // An owned identity is recoverable through login or account recovery; a
  // future authorized-claim response is rendered only when the server names it.
  if (conflict.action === 'request_authorized_claim') {
    return ['request_authorized_claim'];
  }
  return ['login', 'recover_account'];
}

export function getOwnerRegistrationActionLabelKey(action: OwnerRegistrationAction): string {
  switch (action) {
    case 'login':
      return 'goToLogin';
    case 'recover_account':
      return 'recoverAccount';
    case 'request_authorized_claim':
      return 'requestAuthorizedClaim';
  }
}
